import { useI18n } from '@cascade/react/i18n';
import { Text } from '@cascade/ui-library';
import classes from './NoProjects.module.scss';
import { SupportContact } from '#components/support-contact/index.ts';
import { Layout } from '#layout/index.ts';

export const NoProjects = () => {
  const { translate } = useI18n();

  return (
    <Layout mode='card' title={translate('projects.none.title')}>
      <div className={classes['no-projects']}>
        <div className={classes.paragraphs}>
          <Text type='body-2' content={translate('projects.none.unassigned')} />
          <Text
            type='body-2'
            content={translate('projects.none.contactEmployer')}
          />
          <Text
            type='body-2'
            content={translate('projects.none.contactSupport')}
          />
        </div>
        <SupportContact />
      </div>
    </Layout>
  );
};
